import React from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

const NotificationBanner = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f39c12;
  color: white;
  padding: 12px 20px;
  text-align: center;
  z-index: 9999;
  font-weight: 500;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
`;

interface GlobalNotificationProps {
  show: boolean;
  message: string;
}

const GlobalNotification: React.FC<GlobalNotificationProps> = ({ show, message }) => {
  if (!show) return null;

  return createPortal(<NotificationBanner>{message}</NotificationBanner>, document.body);
};

export default GlobalNotification;
